/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { format } from "date-fns";

import makeStyles from "@material-ui/styles/makeStyles";

import {
  List,
  TextField,
  FunctionField,
  Datagrid,
  CreateButton,
  Filter,
  ReferenceInput,
  SelectInput,
  AutoCompleteInput,
  FilterButton,
  ShowButton,
  EditButton
} from "jazasoft";

// import HistoryButton from "../../../components/LibraryHistoryButton";

import { inputOptions, isEmpty } from "../../../utils/helpers";
import hasPrivilege from "../../../utils/hasPrivilege";
import useEntityPrivilege from "../../../hooks/useEntityPrivilege";
import { ResourceId, Scope } from "../../../utils/privilege";

const useStyles = makeStyles(theme => ({
  button: {
    width: theme.spacing(12)
  },
  buttonDelete: {
    width: theme.spacing(16)
  },
  container: {
    margin: theme.spacing(3),
    padding: theme.spacing(3)
  },
  buttonHistory: {
    width: theme.spacing(1)
  }
}));

const Product = props => {
  const classes = useStyles();
  const { roles = [], hasAccess } = props;

  const { disableCreate, disableEdit } = useEntityPrivilege("sizeChart");

  return (
    <List
      actions={({ basePath, roles = [] }) => (
        <div>
          {hasPrivilege(roles, hasAccess, ResourceId.SIZE_CHART, Scope.WRITE) && !disableCreate && (
            <CreateButton basePath={basePath} showLabel={false} />
          )}
          <FilterButton showLabel={false} />
        </div>
      )}
      filters={
        <Filter>
          <ReferenceInput source="productId" reference="products" {...inputOptions(12)}>
            <SelectInput />
          </ReferenceInput>
          <ReferenceInput source="customerId" reference="customers" {...inputOptions(12)}>
            <AutoCompleteInput disablePortal />
          </ReferenceInput>
        </Filter>
      }
      parse={({ productId, customerId }) => ({ "product.id": productId, "customer.id": customerId })}
      {...props}>
      <Datagrid>
        <TextField label="resources.size-chart.fields.customerName" source="customer.name" />
        <TextField label="resources.size-chart.fields.productName" source="product.name" />
        <TextField source="name" />
        <FunctionField
          source="modifiedAt"
          render={record => (!isEmpty(record?.modifiedAt) ? format(record.modifiedAt, "dd MMM yy, hh:mm a") : "-")}
        />
        <TextField source="modifiedBy" />
        {/* <HistoryButton cellClassName={classes.buttonHistory} i18nKey={props.i18nKey} /> */}
        <ShowButton cellClassName={classes.button} />
        {hasPrivilege(roles, hasAccess, ResourceId.SIZE_CHART, Scope.UPDATE) && !disableEdit && <EditButton cellClassName={classes.buttonEdit} />}
      </Datagrid>
    </List>
  );
};

export default Product;
